export const SAVE_MOBILITY_CONFIG_REQUEST = "SAVE_MOBILITY_CONFIG_REQUEST";
export const SAVE_MOBILITY_CONFIG_SUCCESS = "SAVE_MOBILITY_CONFIG_SUCCESS";
export const SAVE_MOBILITY_CONFIG_FAILURE = "SAVE_MOBILITY_CONFIG_FAILURE";
